// components/Common/ErrorDialog.tsx
import React from 'react';
import {
  Dialog,
  Container,
  Typography,
  Paper,
  Box, Button
} from '@mui/material';

function UploadShowError(props: any) {
  return (
    <Dialog open={props.errorViewOpen} maxWidth="sm" fullWidth>
      <Container sx={{ mt: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          에러 메시지
        </Typography>
        <Paper sx={{ p: 2, whiteSpace: 'pre-wrap' }}>
          {props.errorMsg}
        </Paper>
        <Box sx={{ textAlign: 'right', mt: 2 }}>
          <Button onClick={props.handleShowErrorMsgClose} variant="contained">
            닫기
          </Button>
        </Box>
      </Container>
    </Dialog>
  );
}

export default UploadShowError;
